module.exports = __webpack_public_path__ + "img/Quebecor_png.b575f139.png";